"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenManager = void 0;
var JSONChainedToken_1 = __importDefault(require("../lib/JSONChainedToken"));
var Agent_1 = __importDefault(require("./Agent"));
/**
 * This class helps managing token generation, and prevent having to re-generate
 * the same token when used multiple time in a small window.
 *
 * the token key specified should ensure that the token generated will always
 * have the same payload structure, since a call to getToken might not generate
 * a new one
 */
var TokenManager = /** @class */ (function () {
    /**
     *
     * @param agent Agent instance or method that will return the instance,
     * Promised or direct
     * @param paddingTTL Specified in Seconds, the amount of ttl that should be
     * added to the requested one when a new token is generated. This dictacte
     * how long can a token eb reused before having to be generated again
     */
    function TokenManager(agent, paddingTTL) {
        if (paddingTTL === void 0) { paddingTTL = 10; }
        this.agent = null;
        this.agentGetter = null;
        this.tokenGenerators = {};
        this.keyGenerators = {};
        this.tokens = {};
        if (agent instanceof Agent_1.default) {
            this.agent = agent;
        }
        else {
            this.agentGetter = agent;
        }
        this.paddingTTL = paddingTTL;
    }
    TokenManager.prototype.getAgent = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.agent) return [3 /*break*/, 1];
                        return [2 /*return*/, this.agent];
                    case 1:
                        if (!this.agentGetter) return [3 /*break*/, 3];
                        _a = this;
                        return [4 /*yield*/, this.agentGetter()];
                    case 2: 
                    // get the agent, and cache it for the next time
                    return [2 /*return*/, (_a.agent = _b.sent())];
                    case 3: throw new Error('Neither Agent or AgentGetter was set');
                }
            });
        });
    };
    /**
     * Register a token generator to a certain key, allowing multiple location
     * in the code to call the getToken without having to duplicate the
     * generator code
     * @param key string to refer to this kind of token
     * @param generator Method used to generate the token
     */
    TokenManager.prototype.registerTokenGenerator = function (key, tokenGenerator, keyGenerator) {
        this.tokenGenerators[key] = tokenGenerator;
        if (keyGenerator) {
            this.keyGenerators[key] = keyGenerator;
        }
    };
    /**
     * Forcibly clear all tokens
     */
    TokenManager.prototype.clearAll = function () {
        for (var k in this.tokens) {
            this.tokens[k].cancelCleanup();
            delete this.tokens[k];
        }
    };
    /**
     *
     * @param key string to keep the token under
     * @param ttl the desired time to live for the token
     * @param generator method that will generate the new token, if the old one
     * is expired. Should return a ttl higher than the requested one
     */
    TokenManager.prototype.getToken = function (key, ttl, args, generator) {
        if (ttl === void 0) { ttl = 30; }
        if (generator === void 0) { generator = null; }
        return __awaiter(this, void 0, void 0, function () {
            var ttlDate, usableKey, token, parsed, expiresOn, timeoutId;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        ttlDate = new Date();
                        ttlDate.setTime(ttlDate.getTime() + ttl * 1000);
                        usableKey = typeof args !== 'undefined' && key in this.keyGenerators ? this.keyGenerators[key](key, args) : key;
                        if (usableKey in this.tokens) {
                            if (this.tokens[usableKey].expires >= ttlDate) {
                                return [2 /*return*/, this.tokens[usableKey].jct];
                            }
                            else {
                                // a new one will be generated, cancel the cleanup timeout
                                this.tokens[usableKey].cancelCleanup();
                            }
                        }
                        return [4 /*yield*/, this.generateToken(key, ttl, args, generator)];
                    case 1:
                        token = _a.sent();
                        parsed = new JSONChainedToken_1.default(token);
                        expiresOn = new Date();
                        expiresOn.setTime(parsed.expireTimestamp * 1000);
                        timeoutId = setTimeout(function () {
                            delete _this.tokens[usableKey];
                        }, expiresOn.getTime() - new Date().getTime());
                        this.tokens[usableKey] = {
                            expires: expiresOn,
                            jct: token,
                            cancelCleanup: function () { return clearTimeout(timeoutId); },
                        };
                        return [2 /*return*/, token];
                }
            });
        });
    };
    /**
     * Actually generate a new token, either from the provbided generator, or
     * with a previously registered one
     */
    TokenManager.prototype.generateToken = function (key, ttl, args, generator) {
        return __awaiter(this, void 0, void 0, function () {
            var agent;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAgent()];
                    case 1:
                        agent = _a.sent();
                        if (!generator) return [3 /*break*/, 3];
                        return [4 /*yield*/, generator(agent, ttl + this.paddingTTL, args)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        if (!(key in this.tokenGenerators)) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.tokenGenerators[key](agent, ttl + this.paddingTTL, args)];
                    case 4: return [2 /*return*/, _a.sent()];
                    case 5: throw new Error("No generatator registered for " + key + " and none passed to the generateToken method");
                }
            });
        });
    };
    return TokenManager;
}());
exports.TokenManager = TokenManager;
